var TJ_WSChannel = function(config) {
	let wsurlSplitArr = (config.wsurl || '').split('//')
	config.wsurl = (window.location.protocol == 'https:' ? 'wss:' : 'ws:') + '//' + (wsurlSplitArr[1] || '')
	if (!config.success || typeof config.success != 'function') {
		config.success = () => {}
	}
	if (!config.close || typeof config.close != 'function') {
		config.close = () => {}
	}
	if (!config.error || typeof config.error != 'function') {
		config.error = () => {}
	}
	if (!config.receive || typeof config.receive != 'function') {
		config.receive = () => {}
	}
	if (!config.reconnectSuccess || typeof config.reconnectSuccess != 'function') {
		config.reconnectSuccess = () => {}
	}

	this.config = config

	if (!('WebSocket' in window)) {
		this.config.error({
			msg: '您的浏览器不支持HTML5，请升级浏览器至IE10以上！'
		})
		return
	}

	this.createWebSocket()
};
TJ_WSChannel.prototype.createWebSocket = function(isReconnect) {
	if (this.socket) {
		console.error('已经创建了一个链接')
		return
	}

	this.socket = new WebSocket(this.config.wsurl)
	this.socket.onopen = () => {
		console.log('TJ_websocket is connected')

		// 断开后自动重连
		this.reconnect = true

		this.heartBeat()
		if (isReconnect) {
			this.config.reconnectSuccess()
		} else {
			this.config.success()
		}
	};
	this.socket.onmessage = evt => {
		let obj = JSON.parse(evt.data);
		if (obj.msgType != 'hb') {
			console.log('receive msg : ', obj)
			this.config.receive(obj)
		}
	};
	this.socket.onclose = () => {
		console.log('TJ_websocket is closed!');
		this.config.close();
		this.socket = null;
		let self = this

		this.heartBeatInterval && clearInterval(this.heartBeatInterval)

		// 断开重连
		if (!this.reconnect) return;
		setTimeout(function(){
			if (!self.reconnect) return;
			self.createWebSocket(true)
		}, 2500)
	};
	this.socket.onerror = () => {
		console.log('TJ_websocket is connected error!');
		if (!isReconnect) {
			this.config.error({
				msg: '您的网络配置有误，请先联系管理员配置代理！'
			})
		}
	};
};
TJ_WSChannel.prototype.closeWebSocket = function() {
	this.reconnect = false
	this.socket && this.socket.close()
};
TJ_WSChannel.prototype.heartBeat = function() {
	this.heartBeatInterval && clearInterval(this.heartBeatInterval)
	this.heartBeatInterval = setInterval(() => {
		this.socket && this.socket.send('{"msgType":"hb"}')
	}, 30000)
};
TJ_WSChannel.prototype.send = function(data) {
	this.socket && this.socket.send(data)
};
(function() {
	window.TJ_websocket = window.TJ_websocket || {

		login: function(wsUrl, msg, config) {
			wsUrl += '?sessionPrefix=pcweb';
			if(msg.user_account){
				wsUrl += '&clientId=' + msg.user_account;
			}
			if(msg.timeStamp){
				wsUrl += '&timeStamp=' + msg.timeStamp;
			}
			if(msg.sig){
				wsUrl += '&sig=' + msg.sig;
			}

			config.wsurl = wsUrl
			this.connect = new TJ_WSChannel(config)
		},

		logout: function(callback) {
			this.connect && this.connect.closeWebSocket();
			if (callback && typeof callback == 'function') callback();
		},

		sendMsg: function(msg, callback) {
			this.connect && this.connect.send(msg);
			if (callback && typeof callback == 'function') callback();
		},

		pushListener: {},
		// 消息分发池(根据收到消息中msgType的值，执行不同的方法)
		onMsgReceiveListener: function(bCode, callback) {
			this.pushListener[bCode] = callback;
		}
	}
})();


// WEBPACK FOOTER //
// ./src/assets/scripts/TJ_websocket.js